export default __webpack_public_path__ + "static/media/hindermovement1.aa14c594.png";